import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=764428e6&scoped=true"
import script from "./TableTabs.vue?vue&type=script&lang=js"
export * from "./TableTabs.vue?vue&type=script&lang=js"
import style0 from "./TableTabs.vue?vue&type=style&index=0&id=764428e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764428e6",
  null
  
)

export default component.exports